import React from 'react'

import SelectField from '~/components/Fields/SelectField'
import { AREA_STATUS } from '~/components/Statuses/AreaStatus'

export const OPTIONS = [
  { value: AREA_STATUS.ACTIVE, name: 'Active' },
  { value: AREA_STATUS.INACTIVE, name: 'Inactive' }
]

function AreaStatusField (props) {
  return (
    <SelectField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default AreaStatusField
